import React, { useMemo } from "react";

import { Title } from "shared/components";
import { Spacer } from "shared/layout";
import { ChevronRight, TM, Verified } from "shared/assets/icons";
import { IMeta } from "Venues/types";
import { VenueTitleContainer } from "./styles";
import { Link } from "react-router-dom";
import { copy } from "shared/assets";
import { Icon, MutedText } from "shared/styles";
import { colors } from "shared/styles/constants";

const { placeholder } = copy;

interface VenueTitleProps {
  title?: string;
  alternativeName?: string;
  stageTitle?: string;
  meta?: IMeta;
  showPlaceholder?: boolean;
  size?: "l" | "huge";
  venueUrl?: string;
  openInNewTab?: boolean;
}

export const VenueTitle: React.FC<VenueTitleProps> = ({
  title,
  stageTitle,
  alternativeName,
  meta,
  showPlaceholder,
  size = "l",
  venueUrl,
  openInNewTab,
}) => {
  const icon = useMemo(() => {
    if (meta?.createdByTm) {
      return TM;
    }
    if (meta?.createdByVenue) {
      return Verified;
    }
  }, [meta]);

  return (
    <Spacer size="xxs" spaceDirection="vertical">
      <VenueTitleContainer>
        {venueUrl && title ? (
          <Title icon={icon} size={size}>
            <Link
              to={venueUrl}
              target={openInNewTab ? "_blank" : "_self"}
              rel={openInNewTab ? "noopener noreferrer" : ""}
            >
              {stageTitle ? <MutedText>{title}</MutedText> : title}
            </Link>

            {stageTitle && (
              <React.Fragment>
                <Icon as={ChevronRight} color={colors.grey5} />
                <span>{stageTitle}</span>
              </React.Fragment>
            )}
          </Title>
        ) : (
          <Title
            title={title || (showPlaceholder ? placeholder.venueName : "")}
            icon={icon}
            asComponent="span"
            size="huge"
          />
        )}
      </VenueTitleContainer>
      {!stageTitle && alternativeName && (
        <MutedText>{alternativeName}</MutedText>
      )}
    </Spacer>
  );
};
